import {
  ColumnDef,
  flexRenderComponent,
} from '@3ddv/software-division-components/backoffice/table';
import {
  gsActionsColumn,
  gsImageColumn,
} from '../../shared/ui/table/gs-table.columns';
import { GsAdlinkLinkCellComponent } from './cells/gs-adlink-link-cell.component';
import { Adlink } from './models/adlink.model';

export function buildAdlinkColumns(
  onToggleActive: (adlink: Adlink) => void,
  onDelete: (adlink: Adlink) => void,
  onEdit: (adlink: Adlink) => void,
  canEdit = true
): ColumnDef<Adlink>[] {
  const imageColumn = gsImageColumn<Adlink>({
    image: adlink => adlink.urlImage,
    previewOnHover: true,
  });

  const referenceColumn: ColumnDef<Adlink> = {
    id: 'name',
    header: 'Reference',
    accessorFn: adlink => adlink.name,
  };

  const titleColumn: ColumnDef<Adlink> = {
    id: 'title',
    header: 'Title',
    accessorFn: adlink => adlink.title,
  };

  const linkColumn: ColumnDef<Adlink> = {
    id: 'link',
    header: 'Link',
    enableSorting: false,
    cell: context =>
      flexRenderComponent(GsAdlinkLinkCellComponent, {
        inputs: { link: context.row.original.link || null },
      }),
  };

  const actionsColumn = gsActionsColumn<Adlink>({
    actions: [
      {
        id: 'toggle',
        label: adlink => (adlink.active ? 'On' : 'Off'),
        tone: adlink => (adlink.active ? 'positive' : 'negative'),
        dataCy: adlink => `adlink-enable-button-${adlink.id}`,
      },
      {
        id: 'edit',
        label: 'Edit',
        dataCy: adlink => `adlink-edit-button-${adlink.id}`,
      },
      {
        id: 'delete',
        label: 'Delete',
        destructive: true,
        dataCy: adlink => `adlink-delete-button-${adlink.id}`,
      },
    ],
    onSelect: (actionId, adlink) => {
      if (actionId === 'toggle') {
        onToggleActive(adlink);
      } else if (actionId === 'edit') {
        onEdit(adlink);
      } else if (actionId === 'delete') {
        onDelete(adlink);
      }
    },
    rowDataCy: adlink => `adlink-row-${adlink.id}`,
  });

  return [
    imageColumn,
    referenceColumn,
    titleColumn,
    linkColumn,
    ...(canEdit ? [actionsColumn] : []),
  ];
}
